<div class="page-container">
  <div class="row center">
    <div class="col col-50 white">
      <img
        ngSrc="https://aadcdn.msftauthimages.net/c1c6b6c8-ssimvxpb9qdv8nffqqltxmis1nxfqs5utx0cwh6q-vm/logintenantbranding/0/bannerlogo?ts=638043642020989581"
        alt="Company logo"
        width="200"
        height="50"
      />
      <app-spinner [display]="true" [class]="'spinner-container'" />
    </div>
  </div>
</div>
